import { InlineAlert } from '@rbilabs/universal-components';
import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { classifyPaymentMethods } from 'components/payment-method/utils';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants/primitives';

import { SelectorSelection, SelectorSelectionProps } from './selector-selection';

type SelectorPrepaidReloadProps = SelectorSelectionProps & { reloadAmount: number };
export function SelectorPrepaidReload({
  methods,
  selectedMethodId,
  reloadAmount,
  onChange,
}: SelectorPrepaidReloadProps) {
  const { formatMessage } = useIntl();
  const { formatCurrencyForUser } = useUIContext();
  const formattedReloadAmount = formatCurrencyForUser(reloadAmount);
  const { selectedMethod } = classifyPaymentMethods(methods, selectedMethodId ?? '');

  const reloadExplanationText = formatMessage(
    { id: 'reloadExplanation.bk' },
    { reloadAmount: formattedReloadAmount }
  );
  const youWillBeChargedText = formatMessage(
    { id: 'youWillBeCharged' },
    { reloadAmount: formattedReloadAmount }
  );
  const reloadMessage = `${reloadExplanationText} ${youWillBeChargedText}`;

  return (
    <View style={styles.container}>
      <InlineAlert
        message={reloadMessage}
        status="info"
        backgroundColor="#FFCFAD"
        ml="$4"
        mr="$4"
      />

      <View style={styles.labelContainer}>
        <Text style={styles.instructionText}>
          {formatMessage({ id: 'loadWith' })}
          {':'}
        </Text>
        <View style={styles.divider} />
      </View>

      {methods.length > 0 ? (
        <SelectorSelection
          methods={methods}
          selectedMethodId={selectedMethod?.accountIdentifier ?? undefined}
          onChange={onChange}
        />
      ) : (
        <ActionButton
          testID="add-reload-payment-btn"
          width="100%"
          height="$10"
          marginY="$6"
          _text={{ fontSize: 'sm' }}
          variant={ActionButtonVariants.OUTLINE}
          leftIcon={<Icon variant="add" aria-hidden />}
          onPress={onChange}
        >
          {formatMessage({ id: 'addPayment' })}
        </ActionButton>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 0,
    marginVertical: primitive.spacing.$4,
  },
  instructionText: {
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
    fontSize: 18,
    fontWeight: 'normal',
    marginTop: primitive.spacing.$3,
    marginBottom: primitive.spacing.$2,
  },
  divider: { borderBottomWidth: 1, borderBottomColor: primitive.$blackOpacity10 },
  labelContainer: {
    marginTop: primitive.spacing.$3,
    alignSelf: 'center',
    width: '90%',
  },
});
